import React, { useState } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Input,
  FormText,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

import {
  deleteAttendeeByEmail,
  deleteAttendeeByDocument,
  deleteEmployeeByEmail,
  deleteEmployeeByDocument,
  deleteGuestByEmail,
  deleteGuestByDocument,
} from "../../../utils/services/attendeeVibra";

import { isValidCPF } from "../../../utils/helpers/masks/validations";

const RemoveUserVibra = (props) => {
  const location = useLocation();
  const jwt = props.state?.global_user_data?.data?.token;

  const [userType, setUserType] = useState("reseller"); // 👈 NOVO
  const [method, setMethod] = useState("email");
  const [value, setValue] = useState("");
  const [touched, setTouched] = useState(false);

  const [confirmAlert, setConfirmAlert] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [loading, setLoading] = useState(false);

  const [dynamicTitle, setDynamicTitle] = useState("");
  const [dynamicDescription, setDynamicDescription] = useState("");

  const isValidEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    return re.test(String(email).toLowerCase());
  };

  const onlyDigits = (s) => s.replace(/\D/g, "");

  const formatCPF = (digits) => {
    if (!digits) return "";
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
    if (digits.length <= 9)
      return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
    return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(
      6,
      9
    )}-${digits.slice(9, 11)}`;
  };

  const isFieldValid = () => {
    return method === "email" ? isValidEmail(value) : isValidCPF(value);
  };

  const handleMethodChange = (e) => {
    setMethod(e.target.value);
    setValue("");
    setTouched(false);
  };

  const handleValueChange = (e) => {
    let input = e.target.value;

    if (method === "cpf") {
      input = formatCPF(onlyDigits(input).slice(0, 11));
    }

    setValue(input);
    setTouched(true);
  };

  const deleteMapping = {
    reseller: {
      email: deleteAttendeeByEmail,
      cpf: deleteAttendeeByDocument,
    },
    employee: {
      email: deleteEmployeeByEmail,
      cpf: deleteEmployeeByDocument,
    },
    guest: {
      email: deleteGuestByEmail,
      cpf: deleteGuestByDocument,
    },
  };

  const userTypeLabels = {
    reseller: "Revendedor",
    employee: "Time Vibra",
    guest: "Convidado",
  };

  const handleSubmit = () => {
    if (!isFieldValid()) {
      setTouched(true);
      return;
    }
    setConfirmAlert(true);
  };

  const translateErrorMessage = (msg) => {
    if (!msg) return "Ocorreu um erro inesperado.";

    const normalized = msg.toLowerCase();

    if (normalized.includes("email not found")) return "E-mail não encontrado ou o usuário não pertence a esse segmento.";
    if (normalized.includes("document not found")) return "CPF não encontrado ou o usuário não pertence a esse segmento.";

    return "Não foi possível excluir o usuário. Tente novamente.";
  };

  const performDelete = async () => {
    setConfirmAlert(false);
    setLoading(true);

    const eventId = location.state?.idEvent;
    const cleanValue =
      method === "cpf" ? onlyDigits(value) : value.toLowerCase();

    try {
      const deleteFn = deleteMapping[userType][method];

      await deleteFn(eventId, cleanValue, jwt);

      setDynamicTitle("Excluído");
      setDynamicDescription(
        `O usuário do tipo ${userTypeLabels[userType]} foi removido por ${
          method === "cpf" ? "CPF" : "Email"
        }: ${value}`
      );
      setSuccessAlert(true);

      setValue("");
      setTouched(false);
    } catch (err) {
      console.error("Erro ao remover usuário:", err);

      const message = err?.response?.data?.message;
      const translated = translateErrorMessage(message);

      setDynamicTitle("Erro");
      setDynamicDescription(translated);
      setErrorAlert(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {confirmAlert && (
        <SweetAlert
          warning
          showCancel
          title="Confirmar Exclusão"
          confirmBtnText="Sim, excluir"
          cancelBtnText="Cancelar"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="secondary"
          onConfirm={performDelete}
          onCancel={() => setConfirmAlert(false)}
        >
          Tem certeza que deseja excluir o usuário do tipo{" "}
          <b>{userTypeLabels[userType]}</b> por{" "}
          {method === "cpf" ? "CPF" : "Email"}: <b>{value}</b>?
        </SweetAlert>
      )}

      {successAlert && (
        <SweetAlert
          success
          title={dynamicTitle}
          onConfirm={() => setSuccessAlert(false)}
        >
          {dynamicDescription}
        </SweetAlert>
      )}

      {errorAlert && (
        <SweetAlert
          danger
          title={dynamicTitle}
          onConfirm={() => setErrorAlert(false)}
        >
          {dynamicDescription}
        </SweetAlert>
      )}

      <Card>
        <CardBody>
          <CardTitle>Exclusão de Participante</CardTitle>

          <Row className="mt-3">
            <Col md={6}>
              <FormGroup>
                <Label>Tipo de Usuário</Label>
                <Input
                  type="select"
                  value={userType}
                  onChange={(e) => setUserType(e.target.value)}
                >
                  <option value="reseller">Revendedor</option>
                  <option value="employee">Time Vibra</option>
                  <option value="guest">Convidado</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <FormGroup tag="fieldset">
                <Label className="mb-2">Método de Exclusão</Label>

                <div className="d-flex" style={{ gap: 20 }}>
                  <FormGroup check inline>
                    <Input
                      type="radio"
                      id="methodEmail"
                      name="remove-method"
                      value="email"
                      checked={method === "email"}
                      onChange={handleMethodChange}
                    />
                    <Label for="methodEmail">E-mail</Label>
                  </FormGroup>

                  <FormGroup check inline>
                    <Input
                      type="radio"
                      id="methodCPF"
                      name="remove-method"
                      value="cpf"
                      checked={method === "cpf"}
                      onChange={handleMethodChange}
                    />
                    <Label for="methodCPF">CPF</Label>
                  </FormGroup>
                </div>
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label for="remove-value">
                  {method === "cpf" ? "CPF" : "E-mail"}
                </Label>
                <Input
                  id="remove-value"
                  placeholder={
                    method === "cpf" ? "000.000.000-00" : "email@exemplo.com"
                  }
                  value={value}
                  onChange={handleValueChange}
                  onBlur={() => setTouched(true)}
                />

                {touched && method === "email" && !isValidEmail(value) && (
                  <FormText color="danger">E-mail inválido</FormText>
                )}

                {touched && method === "cpf" && !isValidCPF(value) && (
                  <FormText color="danger">CPF inválido</FormText>
                )}
              </FormGroup>
            </Col>
          </Row>

          <Col md={3} className="mt-3">
            <Button
              color="danger"
              disabled={!isFieldValid() || loading}
              onClick={handleSubmit}
              style={{ width: "100%" }}
            >
              {loading ? "Processando..." : "Excluir"}
            </Button>
          </Col>
        </CardBody>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({ state });

export default connect(mapStateToProps)(RemoveUserVibra);
